/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SddcProvidersEnum } from './sddcProvidersEnum';
import { ResourceTypeEnum } from './resourceTypeEnum';


export interface SddcProviders { 
    provider: SddcProvidersEnum;
    /**
     * SDDC Provider Full Name
     */
    name: string;
    /**
     * SDDC provider resource type (BYO, Managed, Inline)
     */
    type: Array<ResourceTypeEnum>;
}
export namespace SddcProviders {
}


